import {
  borderRadius,
  Button,
  Dialog,
  FlexColumn,
  font,
  fontSizes,
  standardSizes,
  StrokeText,
} from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { LoginForm } from './LogIn';
import { useControllerAppModel } from '@/controller/models/ControllerAppModel';

// TODO: Turn this into more of a banner or user icon section
export const UserBanner = observer(() => {
  const appStore = useControllerAppModel();

  const [showLoginDialog, setShowLoginDialog] = useState(false);

  if (appStore.loggedInUser) {
    return (
      <FlexColumn css={[{ zIndex: 100 }]} alignItems="center">
        {appStore.loggedInUser.email && (
          <StrokeText children={`Welcome, ${appStore.userDisplayName ?? 'user'}`} />
        )}
        <Button
          onClick={appStore.signOut}
          css={[borderRadius(standardSizes.sm)]}
          color={`#e0ab24`}
        >
          <StrokeText>Logout</StrokeText>
        </Button>
      </FlexColumn>
    );
  }

  return (
    <>
      <Button
        onClick={() => setShowLoginDialog(!showLoginDialog)}
        css={[font(fontSizes.md), borderRadius(standardSizes.sm)]}
      >
        <StrokeText>Log In</StrokeText>
      </Button>
      <Dialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <LoginForm appStore={appStore} onLoginSuccess={() => setShowLoginDialog(false)} />
      </Dialog>
    </>
  );

  // return (
  //   <>
  //     {!!appStore.loggedInUser ? (
  //       <FlexColumn css={[{ zIndex: 100 }]} alignItems="center">
  //         {appStore.loggedInUser.email && (
  //           <StrokeText children={`Welcome, ${appStore.loggedInUser.email}`} />
  //         )}
  //         <Button
  //           onClick={appStore.signOut}
  //           css={[borderRadius(standardSizes.sm)]}
  //           color={`#e0ab24`}
  //         >
  //           <StrokeText>Logout</StrokeText>
  //         </Button>
  //       </FlexColumn>
  //     ) : (
  //       <Button
  //         onClick={() => setShowLoginDialog(!showLoginDialog)}
  //         css={[font(fontSizes.md), borderRadius(standardSizes.sm)]}
  //       >
  //         <StrokeText>Log In</StrokeText>
  //       </Button>
  //     )}

  //     <Dialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
  //       <LoginForm appStore={appStore} onLoginSuccess={() => setShowLoginDialog(false)} />
  //     </Dialog>
  //   </>
  // );
});
